"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Datalist = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Datalist = ({ id, options }) => ((0, jsx_runtime_1.jsx)("datalist", { id: id, children: options.map(opt => ((0, jsx_runtime_1.jsx)("option", { value: opt }, opt.replace(/\s/g, '')))) }));
exports.Datalist = Datalist;
